import { FC } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import LinkToCustomerService from "@src/i18n/components/LinkToCustomerService";
import { useAppSelector } from "@src/reduxStore";

const ErrorPage: FC<{ hideHeader?: boolean }> = ({
  children,
  hideHeader = false,
}) => {
  const sessionId = useAppSelector(state => state.common.sessionId);

  const defaultMessage = (
    <FormattedMessage
      id="fatalErrorDescription"
      defaultMessage="An unexpected error occurred. Sometimes, there might be a temporary hickup with connections, please try refreshing the page."
    />
  );

  return (
    <div className="container">
      {!hideHeader && (
        <h1>
          <FormattedMessage id="fatalErrorHeader" defaultMessage="Hups!" />
        </h1>
      )}
      <p>{children || defaultMessage}</p>
      <p>
        <FormattedMessage
          id="fatalErrorCTA"
          defaultMessage="Jos ongelma ei poistu, ota yhteyttä <linkToCustomerService>asiakaspalveluun</linkToCustomerService>."
          values={{
            linkToCustomerService: (chunks: HTMLElement) => (
              <LinkToCustomerService>{chunks}</LinkToCustomerService>
            ),
          }}
        />
      </p>
      <p>
        <Code id="error-code">
          <FormattedMessage
            id="fatalErrorCode"
            defaultMessage="<span>Virhekoodi:</span>{errorCode}"
            values={{
              errorCode: sessionId,
              span: (chunks: HTMLElement) => <span>{chunks}</span>,
            }}
          />
        </Code>
      </p>
    </div>
  );
};

const Code = styled.span`
  align-items: center;
  background: hsl(154deg 82% 33% / 20%);
  border: 1px solid hsl(154deg 82% 33% / 50%);
  border-left-color: hsl(154deg 82% 33% / 10%);
  border-top-color: hsl(154deg 82% 33% / 10%);
  display: inline-flex;
  font-family: monospace;
  padding: 0 4px;

  span {
    font-size: 0.8em;
    font-weight: bold;
    text-transform: uppercase;
  }
`;

export default ErrorPage;
